import { UserModel } from './types';

export const isAdmin = (user?: UserModel) => {
  return (
    user &&
    (user.email === 'gunterh@gmail.com' ||
      user.email === 'alejandrojp@uninorte.edu.co' ||
      user.email === 'pchirivi@uninorte.edu.co' ||
      user.email === 'orlandodanielruizh@gmail.com')
  );
};

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
